function LangMap (str, key = '')
{
    const map = 
    {
        IP_WHITELIST: 'IP Whitelist',
        USERNAME_PASSWORD: 'Username & Password',
        IPv4: 'ipv4',
        IPv6: 'ipv6'
    }
    return key == '' ? map[str] : map[key][str]
}
export default LangMap
